import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTopicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" {...props}>
    <path
      fill="#333"
      stroke="#333"
      strokeWidth={0.3}
      d="M25.15 4.52v-.087l-.076-.043-6.19-3.52-.074-.042-.075.042-5.725 3.257L7.283.87 7.208.827 7.134.87.944 4.41l-.076.044v.087L.85 18.18v.087l.076.043 12.008 6.82.074.043.075-.043 6.19-3.521.076-.043V14.969l5.725-3.278.076-.044V4.52Zm-22.682.231 4.741-2.696 4.657 2.649h-.002l.084.048-4.74 2.696-4.74-2.697Zm15.805 16.2-4.725 2.688v-5.37l4.725-2.689v5.371ZM14.09 4.741l4.722-2.686 4.704 2.675-4.722 2.686-4.704-2.675ZM7.747 8.37l4.725-2.687v5.35l-4.725 2.687V8.37Zm5.245 8.946L8.307 14.65l4.685-2.665 4.737 2.676-4.737 2.654ZM24.074 5.66v5.37l-4.726 2.689V8.349l4.726-2.688Z"
    />
  </svg>
);
export default SvgTopicIcon;
